import React from 'react';
import { MapPinIcon, StarIcon } from 'lucide-react';
import { Section } from './Section';
import { deepQuotes } from '../data/content';
export function Testimonials() {
  return <Section tone="tint" eyebrow="Quiénes ya lo tienen" title="Más familias que ya dejaron de improvisar" data-id="element-225" data-mp="3fznrfeogiyy7">
      <ul className="mx-auto max-w-narrow divide-y divide-blue-200/70" data-id="element-226" data-mp="3b0ucrixfp1wg">
        {deepQuotes.map(quote => <li key={`${quote.author}-${quote.city}`} className="grid gap-4 py-7 first:pt-0 last:pb-0 md:grid-cols-[minmax(0,15rem)_1fr] md:gap-10" data-id="element-227" data-mp="36z97ain8bpwa">
            <div className="flex items-start gap-3" data-id="element-228" data-mp="2x0jlwfw4jnba">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-blue-600 font-display text-xs font-bold text-white" data-id="element-229" data-mp="2x1bgpohwdh0i">
                {quote.initials}
              </span>
              <span data-id="element-230" data-mp="v8nb58hs6hhk">
                <span className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-231" data-mp="v72ftgnn6uin">
                  {Array.from({
                length: 5
              }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-blue-500 text-blue-500" aria-hidden="true" data-id="element-232" data-mp="h4wsxwwqs2fk" data-mpi={index} />)}
                </span>
                <span className="mt-1.5 block font-display font-extrabold tracking-tight text-ink" data-id="element-233" data-mp="77s6dvyzi4y8">
                  {quote.author}
                </span>
                <span className="inline-flex items-center gap-1 text-sm text-blue-900/60" data-id="element-234" data-mp="c7myg2uhx0kv">
                  <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-235" data-mp="zxr0i5s1cs9r" />
                  {quote.city}
                </span>
              </span>
            </div>
            <blockquote className="text-lg italic leading-relaxed text-ink md:text-xl" data-id="element-236" data-mp="q6wb4sjhtck3">
              “{quote.quote}”
            </blockquote>
          </li>)}
      </ul>
    </Section>;
}